import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SupplierAdminContactListItem = ResultOf<
  typeof supplierAdminContactList
>["supplierAdminContacts"]["data"][number];

export const supplierAdminContactList = graphql(`
  query supplierAdminContactList(
    $supplierId: ID!
    $page: Int!
    $first: Int!
    $orderBy: [QuerySupplierAdminContactsOrderByOrderByClause!]
  ) {
    supplierAdminContacts(
      first: $first
      page: $page
      supplier_id: $supplierId
      orderBy: $orderBy
    ) {
      data {
        id
        name
        email
        phone
        role
        description
        created_at
        updated_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export const supplierAdminContactRecord = graphql(`
  query supplierAdminContactRecord($id: ID!) {
    supplierAdminContact(id: $id) {
      id
      name
      email
      phone
      role
      description
    }
  }
`);
